import {
  GetSottoscrizioneInstallatoreSubscription,
  GetSottoscrizioniInstallatoreSubscription,
  Order_By,
  Sottoscrizione_Order_By,
} from '../../../../_core/_graphql/generated';

import { DeepPartial } from '@apollo/client/utilities';

export type InstallatoreState = {
  sottoscrizioni_loading: boolean;
  sottoscrizioni_data?: GetSottoscrizioniInstallatoreSubscription['search_sottoscrizioni'];
  sottoscrizioni_filter: boolean;
  sottoscrizioni_filter_data: any;
  sottoscrizioni_page: number;
  sottoscrizioni_page_size: number;
  sottoscrizioni_total: number;
  sottoscrizioni_search: string;
  sottoscrizioni_active_filter: any;
  sottoscrizioni_order_by: Sottoscrizione_Order_By[];

  cabina_loading: boolean;
  cabina_data?: number[];

  selected_sottoscrizione_loading: boolean;
  selected_sottoscrizione?: GetSottoscrizioneInstallatoreSubscription['sottoscrizione_by_pk'];

  failure?: any;
};

export const initialInstallatoreState: InstallatoreState = {
  cabina_loading: false,
  cabina_data: undefined,

  sottoscrizioni_loading: true,
  sottoscrizioni_data: undefined,
  sottoscrizioni_filter: false,
  sottoscrizioni_filter_data: undefined,
  sottoscrizioni_page: 0,
  sottoscrizioni_page_size: 10,
  sottoscrizioni_total: 0,
  sottoscrizioni_search: '',
  sottoscrizioni_active_filter: undefined,
  sottoscrizioni_order_by: [{ updated_at: Order_By.Desc }],

  selected_sottoscrizione_loading: true,
  selected_sottoscrizione: undefined,

  failure: undefined,
};
